<ng-container
  *ngIf="{
    users: users$ | async,
  } as $"
>
  <div>
    <mat-tab-group>
      <mat-tab label="{{ 'ADMIN_PAGE.CONFIGURATIONS.TITLE' | translate }}">
        <div
          class="flex h-full w-full flex-col items-center justify-center p-8"
        >
          <form
            class="grid w-fit grid-cols-2 gap-x-8 gap-y-4"
            [formGroup]="configForm"
            (ngSubmit)="onSubmit()"
          >
            <mat-form-field class="col-span-2">
              <mat-label>
                {{ 'ADMIN_PAGE.CONFIGURATIONS.YEAR_LABEL' | translate }}
              </mat-label>
              <input matInput [formControlName]="'workingYear'" />
              @if (configForm.controls['workingYear'].hasError('required')) {
                <mat-error>
                  {{
                    'ADMIN_PAGE.CONFIGURATIONS.VALIDATION.REQUIRED_FIELD'
                      | translate
                  }}
                </mat-error>
              }
            </mat-form-field>

            <mat-label class="col-span-2">
              {{ 'ADMIN_PAGE.CONFIGURATIONS.PERIOD_LABEL' | translate }}
            </mat-label>
            <mat-form-field>
              <mat-label>
                {{ 'ADMIN_PAGE.CONFIGURATIONS.START_DATE' | translate }}
              </mat-label>
              <input
                matInput
                [matDatepicker]="startDatePicker"
                [formControlName]="'startDate'"
              />
              @if (configForm.controls['startDate'].hasError('required')) {
                <mat-error>
                  {{
                    'ADMIN_PAGE.CONFIGURATIONS.VALIDATION.REQUIRED_FIELD'
                      | translate
                  }}
                </mat-error>
              }
              <mat-datepicker-toggle matIconSuffix [for]="startDatePicker" />
              <mat-datepicker #startDatePicker />
            </mat-form-field>

            <mat-form-field>
              <mat-label>
                {{ 'ADMIN_PAGE.CONFIGURATIONS.START_TIME' | translate }}
              </mat-label>
              <input
                matInput
                [matTimepicker]="startTimePicker"
                [formControlName]="'startTime'"
              />
              @if (configForm.controls['startTime'].hasError('required')) {
                <mat-error>
                  {{
                    'ADMIN_PAGE.CONFIGURATIONS.VALIDATION.REQUIRED_FIELD'
                      | translate
                  }}
                </mat-error>
              }

              <mat-timepicker-toggle
                matIconSuffix
                [for]="startTimePicker"
              ></mat-timepicker-toggle>
              <mat-timepicker #startTimePicker />
            </mat-form-field>

            <mat-form-field>
              <mat-label>
                {{ 'ADMIN_PAGE.CONFIGURATIONS.END_DATE' | translate }}
              </mat-label>
              <input
                matInput
                [matDatepicker]="endDatePicker"
                [formControlName]="'endDate'"
              />
              @if (configForm.controls['endDate'].hasError('required')) {
                <mat-error>
                  {{
                    'ADMIN_PAGE.CONFIGURATIONS.VALIDATION.REQUIRED_FIELD'
                      | translate
                  }}
                </mat-error>
              }
              <mat-datepicker-toggle
                matIconSuffix
                [for]="endDatePicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #endDatePicker />
            </mat-form-field>

            <mat-form-field>
              <mat-label>
                {{ 'ADMIN_PAGE.CONFIGURATIONS.END_TIME' | translate }}
              </mat-label>
              <input
                matInput
                [matTimepicker]="endTimePicker"
                [formControlName]="'endTime'"
              />
              @if (configForm.controls['endTime'].hasError('required')) {
                <mat-error>
                  {{
                    'ADMIN_PAGE.CONFIGURATIONS.VALIDATION.REQUIRED_FIELD'
                      | translate
                  }}
                </mat-error>
              }
              <mat-timepicker-toggle
                matIconSuffix
                [for]="endTimePicker"
              ></mat-timepicker-toggle>
              <mat-timepicker #endTimePicker />
            </mat-form-field>
            @if (configForm.errors) {
              <mat-error class="mb-2">
                {{
                  'ADMIN_PAGE.CONFIGURATIONS.VALIDATION.DEPARTURE_DATE_CANNOT_BE_AFTER_ARRIVAL_DATE'
                    | translate
                }}
              </mat-error>
            }
            <div
              class="col-span-2 flex items-center justify-center"
              cdkTrapFocus
            >
              <button
                mat-flat-button
                type="submit"
                [disabled]="!configForm.valid"
                [attr.aria-label]="
                  'ADMIN_PAGE.CONFIGURATIONS.ACTIONS.UPDATE_ARIA_LABEL'
                    | translate
                "
                class="focus-visible focus:ring-3 focus:ring-purple-800"
              >
                <span>
                  {{ 'ADMIN_PAGE.CONFIGURATIONS.ACTIONS.UPDATE' | translate }}
                </span>
              </button>
            </div>
          </form>
        </div>
      </mat-tab>
      <mat-tab label="{{ 'ADMIN_PAGE.USERS.TITLE' | translate }}">
        <dnv-users-table
          [tableData]="$.users"
          [isDataImportVisible]="isDataImportVisible"
          [isDataImportCompleted]="isDataImportCompleted"
          [isDataImportValid]="isDataImportValid"
          (new)="handleNew($event)"
          (edit)="handleEdit($event)"
          (import)="handleImport($event)"
          (delete)="handleDelete($event)"
          (deleteAllUsers)="handleDeleteAllUsers()"
        />
      </mat-tab>
    </mat-tab-group>
  </div>
</ng-container>
